import React from "react";

const InputLoading = ({ show, top = "35px", right = "30px" }) => {
  if (!show) {
    return null;
  }

  return (
    <div style={{ position: "absolute", right: right, top: top, zIndex: 10 }}>
      <div 
        className="spinner-border spinner-border-sm" 
        role="status" 
        style={{ width: "16px", height: "16px", borderWidth: "2px" }}
      >
        <span className="sr-only"></span>
      </div>
    </div>
  );
};

export default InputLoading;
